import { render, staticRenderFns } from "./firm.vue?vue&type=template&id=62908a5f"
import script from "./firm.vue?vue&type=script&lang=js"
export * from "./firm.vue?vue&type=script&lang=js"
import style0 from "./firm.vue?vue&type=style&index=0&id=62908a5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports